module.exports = __webpack_public_path__ + "img/NgBoonKhim_140x140_rund.10fb020d.jpg";